// Components==============
import Button from 'components/UI/Button/Button';
import Checkbox from 'components/UI/Checkbox/Checkbox';
import Modal from 'components/UI/Modal/Modal';
import { useTranslate } from 'hooks/useTranslate';
import { TrainingDetailsContext } from 'pages/Workspace/TrainingDetails/TrainingDetails';
import React, { useContext, useState } from 'react';
import './FinishConceptModal.module.scss';
// =========================

export default function FinishConceptModal({
  setModalIsOpen,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [isChecked, setIsChecked] = useState(false);
  const translate = useTranslate();

  const { handlePublish } = useContext(TrainingDetailsContext);

  function onClick() {
    handlePublish('private');
    setModalIsOpen(false);
  }

  return (
    <Modal setModalIsOpen={setModalIsOpen} size="medium">
      <div styleName="content-wrapper">
        <img src="/images/publication-popup-image.svg" alt="popup" />
        <h2>{translate('course.finish-concept-popup.title')}</h2>
        <p>{translate('course.finish-concept-popup.text01')}</p>
        <p>
          <strong>{translate('course.finish-concept-popup.sub-title')}</strong>
          {translate('course.finish-concept-popup.text02')}
          <br />
          {translate('course.finish-concept-popup.text03')}
          <br />
          <br />
        </p>
        <Checkbox isChecked={isChecked} setIsChecked={setIsChecked}>
          {translate('course.finish-concept-popup.checkboxlabel')}
        </Checkbox>
        <div styleName="button-wrapper">
          <Button color="grey" onClick={() => setModalIsOpen(false)}>
            {translate('general.terms.cancel')}
          </Button>
          <Button onClick={onClick} inactive={!isChecked}>
            {translate('general.terms.finish')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
